// 接口请求路径
// const api_url = 'http://api.jeachou.com';
// 临时域名
const api_url = 'https://api.gizonet.com';

// oss 
var accessKeyId = 'LTAI4G8gDoTkgVb8ABvHK2fC';
var accessKeySecret = 'GfVqOsmsL5aljnE8qKmLNrxMpbPXNf';
var bucket = 'fth-gizonet';
var region = 'oss-cn-qingdao';
var bucket_url = 'https://fth-gizonet.oss-cn-qingdao.aliyuncs.com/';

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
  }
  
  const formatTime = (date, e) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
  
    if (e == 1) {
      return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
    } else if (e == 2) {
      return [year, month, day].map(formatNumber).join('.');
    } else if (e == 3) {
      return [year, month, day].map(formatNumber).join('-');
    } else if (e == 4) {
      return year + '' + month + '' + day
    }
  }

export default {
  api_url,
  accessKeyId,
  accessKeySecret,
  bucket,
  region,
  bucket_url,
  formatTime
}



// WEBPACK FOOTER //
// ./src/util/common.js